import { render, staticRenderFns } from "./DimensionsListItem.vue?vue&type=template&id=ab00445e"
import script from "./DimensionsListItem.vue?vue&type=script&lang=js"
export * from "./DimensionsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports